// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5376) return "static/chunks/5376-ebb23222d81049cd.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"7405":"c9f7b777","9642":"17d537d6"}[chunkId] || chunkId) + "." + {"1268":"369c07f73c7d79ff","2347":"b320e240cce44195","2705":"2423603a4be0b671","2935":"1cb5eaf61cb4d359","3607":"7aef459459b368fe","7405":"91395632f8535ff0","8736":"a2c0a608141c508c","9642":"305a903139fb82ec","9949":"c9c1afca123942a9"}[chunkId] + ".js";
};